import { useState, useEffect } from 'react';

import { ReactComponent as RubBtn } from '../../components/header/currency.picker/icons/rub.svg';
import { ReactComponent as CnyBtn } from '../../components/header/currency.picker/icons/cny.svg';
import { ReactComponent as UsdBtn } from '../../components/header/currency.picker/icons/usd.svg';
import { ReactComponent as EurBtn } from '../../components/header/currency.picker/icons/eur.svg';

import { CoT_MODE, DEAL_PRICE_WATCH_MODE } from '../../../settings/constants';
import { PopupActionButtons, PopupTitle, usePopup } from '../popup';
import Textfield from '../../components/textfield';
import useGlobal from '../../../store';
import ToggleSlider from '../../components/toggleslider';

import "./popup.settings.scss";
import useReloadDummy from '../../../scripts/hooks/use.reload.dummy';

const PopupSettings = () => {

  const [ Dummy, reloadDummy ] = useReloadDummy();
  const [ globalState, globalActions ] = useGlobal();

  const { 

    popup_opened,
    wanted_result_rub,
    wanted_result_cny,
    wanted_result_usd,
    wanted_result_eur,
    tariff_comission,
    deal_price_watch_mode,
    comission_or_time,
    popup_settings_only_save
    
  } = globalState;

  const { popup, settings } = globalActions;

  const [ comission, setComission ] = useState( tariff_comission  || 0 );
  const [ wantedRUB, setWantedRUB ] = useState( wanted_result_rub || 0 );
  const [ wantedCNY, setWantedCNY ] = useState( wanted_result_cny || 0 );
  const [ wantedUSD, setWantedUSD ] = useState( wanted_result_usd || 0 );
  const [ wantedEUR, setWantedEUR ] = useState( wanted_result_eur || 0 );
  const [ priceWatchMode, setPriceWatchMode ] = useState( deal_price_watch_mode || DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER );
  const [ comissionOrTimeMode, setComissionOrTimeMode ] = useState( comission_or_time || CoT_MODE.COMISSION );

  useEffect(() => {
    
    setComission( tariff_comission  || 0 );
    setWantedRUB( wanted_result_rub || 0 );
    setWantedCNY( wanted_result_cny || 0 );
    setWantedUSD( wanted_result_usd || 0 );
    setWantedEUR( wanted_result_eur || 0 );
    setPriceWatchMode( deal_price_watch_mode || DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER );
    setComissionOrTimeMode( comission_or_time || CoT_MODE.COMISSION );

    reloadDummy();

  }, [

    popup_opened,
    wanted_result_rub,
    wanted_result_cny,
    wanted_result_usd,
    wanted_result_eur,
    tariff_comission,
    deal_price_watch_mode,
    comission_or_time

  ]);

  const TOGGLESLIDER_CONVERTER = {
    
    DEAL_PRICE_WATCH_MODE: {

      [ DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER ]: 0,
      [ DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL ]: 1

    },

    SET_DEAL_PRICE_WATCH_MODE: {

      0: DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER,
      1: DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL
  
    },

    TIME_OR_COMISSION_MODE: {

      [ CoT_MODE.COMISSION ]: 0,
      [ CoT_MODE.TIME ]: 1,

    },

    SET_TIME_OR_COMISSION_MODE: {

      0: CoT_MODE.COMISSION,
      1: CoT_MODE.TIME,

    }

  }

  const CONTENT = (

    <div className = "popup-settings">

      <Dummy />

      <PopupTitle>Настройки</PopupTitle>

      <div className = "popup__row commission border-bottom flex items-center">

        Укажите комиссию биржи согласно вашему тарифу (в процентах):
        
        <div className = "flex items-center">

          <Textfield

            value = { comission }
            set = { setComission }
          
          />

          <div className = "commission__percentchar">%</div>

        </div>
        
      </div>

      <div className = "popup__row flex items-center">

        Укажите минимальный желаемый результат от сделки (в сумме торгуемой валюты):

      </div>
      
      <div className = "popup__row border-bottom">

        <div className = "currency_wanted_result flex flex-1 justify-between items-center">
            
          <WantedResultSetter

            value = { wantedRUB }
            set = { setWantedRUB }
            icon = { <RubBtn /> }

          />

          <div className = "vertical desktop" />

          <WantedResultSetter

            value = { wantedCNY }
            set = { setWantedCNY }
            icon = { <CnyBtn /> }

          />

          <div className = "vertical desktop" />

          <WantedResultSetter

            value = { wantedUSD }
            set = { setWantedUSD }
            icon = { <UsdBtn /> }

          />

          <div className = "vertical desktop" />

          <WantedResultSetter

            value = { wantedEUR }
            set = { setWantedEUR }
            icon = { <EurBtn /> }

          />

        </div>

        <br />

        <div className = "tip">

          На основе этого числа будет подсчитываться цена инструмента по которой нужно закрыть сделку,
          чтобы получить этот результат. Например, если укажете 0 - Скалькулятор будет считать цену 
          не ниже которой нужно продать, чтобы выйти в безубыток. Также можно указать любое число.

        </div>

      </div>

      <div className = "popup__row price_watch_mode flex items-center justify-between">
        
        При фиксации продажи или покупки, вам удобнее указывать цену:

        <ToggleSlider

          selected = { TOGGLESLIDER_CONVERTER.DEAL_PRICE_WATCH_MODE[ priceWatchMode ] }
          select = { value => setPriceWatchMode( TOGGLESLIDER_CONVERTER.SET_DEAL_PRICE_WATCH_MODE[ value ] ) }
          list = {[ "за один лот", "за все лоты" ]}

        />

      </div>

      <div className = "popup__row price_watch_mode flex items-center justify-between">
        
        В покупках и продажах внутри сделки вы хотите видеть:

        <ToggleSlider

          selected = { TOGGLESLIDER_CONVERTER.TIME_OR_COMISSION_MODE[ comissionOrTimeMode ] }
          select = { value => setComissionOrTimeMode( TOGGLESLIDER_CONVERTER.SET_TIME_OR_COMISSION_MODE[ value ] ) }
          list = {[ "комиссию", "время" ]}

        />

      </div>

      <PopupActionButtons

        confirmText = "Сохранить"
        confirm = { () => { settings.update({ comission, wantedRUB, wantedCNY, wantedUSD, wantedEUR, priceWatchMode, comissionOrTimeMode }) } }
        cancel = { popup.hide }
        hideCancel = { popup_settings_only_save }

      />

    </div>

  );

  const thisPopup = usePopup({ name: "settings", content: CONTENT });

  return thisPopup;

}

const WantedResultSetter = ({ value, set, icon }) => (

  <div className = "wrsetter flex items-center">

    <Textfield

      value = { value }
      set = { set }

    />

    { icon }

  </div>

)

export default PopupSettings;